'use strict';

angular.module('cgmemApp')
  .factory('Logger', function ($http, $log) {
		
		var api = {}
		
		api.log = function (args) {
			$http.post('/api/logs',JSON.stringify(arguments));
		}

							
		return api;
  });
